// extracted by mini-css-extract-plugin
export var button = "_q-0";
export var buttonContent = "_q-e";
export var buttonGroup = "_q-c";
export var dontRestrainIconWidth = "_q-a";
export var dropdownButton = "_q-b";
export var iconContainer = "_q-9";
export var lg = "_q-4";
export var md = "_q-3";
export var pending = "_q-f";
export var sm = "_q-2";
export var spinner = "_q-d";
export var squared = "_q-8";
export var wrapText = "_q-g";
export var xl = "_q-5";
export var xs = "_q-1";
export var xxl = "_q-6";
export var xxxl = "_q-7";